var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.945V17.6h-3.858v-6.21c0-1.559-.558-2.623-1.954-2.623-1.067 0-1.7.717-1.98 1.411-.102.248-.128.593-.128.94V17.6H6.22s.053-10.516 0-11.606h3.86V7.64l-.026.038h.026V7.64c.512-.79 1.428-1.917 3.477-1.917 2.54 0 4.443 1.658 4.443 5.223zM2.184.4C.864.4 0 1.266 0 2.405 0 3.519.839 4.41 2.133 4.41h.025c1.346 0 2.183-.892 2.183-2.006C4.316 1.265 3.504.4 2.184.4zM.229 17.6h3.858V5.994H.229V17.6z",
    fill: "#007BB5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinked);
export default __webpack_public_path__ + "static/media/linked.dd328e885370f595b2b9e75a199fcb76.svg";
export { ForwardRef as ReactComponent };